var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosoftlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_171",
    "data-name": "Group 171",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M737.358,387.022c3.122,0,6.244,0,9.366-.008.275,0,.332.056.331.331-.012,3.122-.008,6.244-.008,9.366a.411.411,0,0,1-.09.02c-3.1,0-6.21,0-9.315.012-.352,0-.31-.193-.31-.409,0-1.8,0-3.6,0-5.4C737.337,389.633,737.35,388.328,737.358,387.022Z",
    transform: "translate(-727.055 -387.014)",
    fill: "#4fa13a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M691.7,452.061c-3.115,0-6.23,0-9.344.008-.288,0-.354-.065-.353-.353.012-3.115.008-6.229.008-9.344q4.7-.011,9.393-.028c.334,0,.321.188.321.416,0,1.443,0,2.886,0,4.329C691.715,448.746,691.7,450.4,691.7,452.061Z",
    transform: "translate(-682 -432.068)",
    fill: "#287ec3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M747.032,442.37c0,3.115,0,6.229.008,9.344,0,.288-.065.354-.353.353-3.115-.012-6.229-.008-9.344-.008a.916.916,0,0,1-.02-.136c0-3.072,0-6.144-.011-9.217,0-.335.145-.366.413-.364,1.567.008,3.134,0,4.7,0C743.961,442.351,745.5,442.362,747.032,442.37Z",
    transform: "translate(-727.04 -432.067)",
    fill: "#ffb100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M682.008,396.62c0-3.084,0-6.168-.008-9.252,0-.288.065-.354.353-.353,3.084.012,6.168.007,9.252.007q0,4.494,0,8.987c0,.608,0,.61-.61.61Z",
    transform: "translate(-682 -387.016)",
    fill: "#e82c29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M691.727,387.053q.008,4.7.021,9.4c0,.242-.068.311-.31.31q-4.7-.019-9.4-.022v-.092h8.987c.608,0,.609,0,.61-.61q0-4.494,0-8.987Z",
    transform: "translate(-682.03 -387.045)",
    fill: "#e8201c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftlogo);
export default __webpack_public_path__ + "static/media/microsoftlogo.83de6120be5f1d1d0682bb4bab3c7ffa.svg";
export { ForwardRef as ReactComponent };